export enum RoundsSortField {
  NAME = 'name',
  NAME_DESC = '-name',
  OPENED_AT = 'openedAt',
  OPENED_AT_DESC = '-openedAt',
  CLOSED_AT = 'closedAt',
  CLOSED_AT_DESC = '-closedAt',
  CREATED_AT = 'createdAt',
  CREATED_AT_DESC = '-createdAt',
  PRIZE_AMOUNT = 'prizeAmount',
  PRIZE_AMOUNT_DESC = '-prizeAmount',
}
